/**
 * Shared strings — buttons and generic UI elements.
 *
 * Namespace: common
 */
export const common = {
  // Buttons
  loading: "Betöltés...",
  save: "Mentés",
  cancel: "Mégse",
  back: "Vissza",
  next: "Tovább",
  submit: "Küldés",
  retry: "Próbálja újra",
  close: "Bezárás",
  yes: "Igen",
  no: "Nem",

  // Form
  required: "Kötelező mező",

  // reCAPTCHA attribution
  recaptcha: {
    footerText: "Ez az űrlap reCAPTCHA védelme alatt áll. A Google",
    privacy: "Adatvédelmi szabályzata",
    and: "és",
    terms: "Szolgáltatási feltételei",
    apply: "érvényesek.",
  },
} as const;

export type CommonMessages = typeof common;
